import React from 'react';
import { Button, Col, Row } from 'antd';

import { broadcastStatus } from '../utils/options';

export const MassBroadcastsModalButtons = ({
    status,
    handleClose,
    handleCansel,
    handleEdit,
    broadcastId,
    isLoadingUpdate,
}) => {
    const canEdit =
        status === broadcastStatus.planned ||
        status === broadcastStatus.cancelled;
    const canCancel =
        status === broadcastStatus.planned ||
        status === broadcastStatus.starting;
    const isFinalStatus =
        status === broadcastStatus.inProgress ||
        status === broadcastStatus.finished;

    return (
        <Row gutter={[48, 0]}>
            <Col span={12}>
                <Button style={{ width: '100%' }} onClick={handleClose}>
                    Закрыть
                </Button>
            </Col>
            <Col span={12}>
                <Button
                    style={{ width: '100%', marginBottom: 8 }}
                    type='default'
                    disabled={!canEdit}
                    onClick={() => handleEdit(broadcastId)}
                >
                    Редактировать
                </Button>
                {canCancel && (
                    <Button
                        style={{ width: '100%' }}
                        type='primary'
                        disabled={isLoadingUpdate || isFinalStatus}
                        onClick={handleCansel}
                    >
                        Отменить рассылку
                    </Button>
                )}
                {status === broadcastStatus.cancelled && (
                    <Button
                        style={{ width: '100%' }}
                        type='primary'
                        onClick={() => handleEdit(broadcastId)}
                    >
                        Возобновить
                    </Button>
                )}
            </Col>
        </Row>
    );
};
